import LeadsAuditoryTable from "../features/leads-auditory/components/leads-auditory-table";

export default function LeadsAuditoryView() {
  return (
    <>
      <LeadsAuditoryTable/>
    </>
  )
}